/** localStorage keys for session JWT — single source of truth (AccessService, VkCallbackPage, etc.). */
export const AUTH_TOKEN_STORAGE_KEY = 'authToken';
export const AUTH_TOKEN_TS_STORAGE_KEY = 'authTokenTS';
